/**
 * bomLibraryErrors.js — turns a business rejection of Sun into the user's language.
 *
 * Sun's literals are the i18n keys (repo convention), so a FIXED literal translates with a plain
 * `t_(literal)`. The ones that carry a value do not: "Component does not exist in the catalog:
 * HUN-ASCOD" never matches a key, and the PO saw them raw in English on 2026-09-15. Each pattern
 * below is one of Sun's `String.format` messages with its `%s`/`%d` turned into `{{value}}`, so the
 * fixed part translates and the value travels untouched.
 *
 * An unknown literal comes back as `t_(literal)`: never swallowed, never invented.
 */
const VALUED_LITERALS = [
  [/^Component does not exist in the catalog: (.+)$/, 'Component does not exist in the catalog: {{value}}'],
  [/^Position has no parent: (.+)$/, 'Position has no parent: {{value}}'],
  [/^Mandatory field empty: (.+)$/, 'Mandatory field empty: {{value}}'],
  [/^Unknown BOM index value: (.+)$/, 'Unknown BOM index value: {{value}}'],
  [/^BOM position is not valid: (.+)$/, 'BOM position is not valid: {{value}}'],
  [/^BOM component not found in this version: (.+)$/, 'BOM component not found in this version: {{value}}'],
  [/^Duplicated BOM version number: (.+)$/, 'Duplicated BOM version number: {{value}}'],
  [/^Version is in use by (\d+) workflow\(s\)$/, 'Version is in use by {{value}} workflow(s)'],
  [/^BOM code must not exceed (\d+) characters$/, 'BOM code must not exceed {{value}} characters']
]

export const translateBomLibraryError = (t_, literal) => {
  if (typeof literal !== 'string' || literal === '') return ''
  for (const [pattern, key] of VALUED_LITERALS) {
    const match = pattern.exec(literal)
    if (match) return t_(key, { value: match[1] })
  }
  return t_(literal)
}
